import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=6624943e&scoped=true&"
import script from "./refund.vue?vue&type=script&lang=js&"
export * from "./refund.vue?vue&type=script&lang=js&"
import style0 from "./refund.vue?vue&type=style&index=0&id=6624943e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624943e",
  null
  
)

export default component.exports